<template>
  <section class="mh-portfolio" id="portfolio-gallery">
    <div class="container">
      <!-- Start: .row -->
      <div class="row section-separator">
        <div
          class="section-title col-sm-12 wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.1s"
        >
          <h3>Recent Portfolio</h3>
        </div>
        <!-- Start: .part -->

        <container :categories="categories" @view-more="log(stack)">
          <tab-item
            v-for="(stack, index) in portfolio_stacks"
            :key="index"
            :stack="stack"
          ></tab-item>
        </container>

        <!-- End: .part -->
      </div>
      <!-- End: .row -->
    </div>

    <portfolio-modal :stack="currentStack" />
  </section>
</template>

<script>
import PortfolioModal from "@/components/Portfolio/PortfolioModal.vue";
import Container from "@/components/Portfolio/Container.vue";
import TabItem from "@/components/Portfolio/TabItem.vue";

export default {
  data() {
    return {
      currentStack: {},
      categories: [],
      portfolio_stacks: [],
    };
  },

  computed: {
    // return [
    // {
    // 	id: "Stackreads",
    // 	title: "Online Library",
    // 	subtitle: "Ton of books",
    // 	location: "",
    // 	categories: [this.categories.web, this.categories.server],
    // 	tags: [this.skills.html, this.skills.css, this.skills.javaScript, this.skills.node, this.skills.php, this.skills.express]
    // },
    // {
    // 	id: "Blog",
    // 	title: "Swift Blog",
    // 	subtitle: "Built with Laravel",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fblog.gif?alt=media&token=7d4e6b03-b567-44e8-b39b-eabfb07f3bd6",
    // 	categories: [this.categories.server, this.categories.web],
    // 	tags: [this.skills.html, this.skills.css, this.skills.javaScript, this.skills.php, this.skills.laravel, this.skills.oop]
    // },
    // {
    // 	id: "G6",
    // 	title: "Creative Design",
    // 	subtitle: "Photoshop",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fg6.png?alt=media&token=c934decb-93f7-421c-b9b1-0e80580ea3b1",
    // 	categories: [this.categories.design],
    // 	tags: []
    // },
    // {
    // 	id: "Portfolio Dark",
    // 	title: "Portfolio",
    // 	subtitle: "Dark background",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fportfolio-dark.gif?alt=media&token=960175d5-45ac-4f3e-a6e2-498228882c95",
    // 	categories: [this.categories.web, this.categories.firebase, this.categories.nodejs],
    // 	tags: [this.skills.html, this.skills.css, this.skills.javaScript, this.skills.node, this.skills.vue]
    // },
    // {
    // 	id: "Store",
    // 	title: "Andii Market",
    // 	subtitle: "Laravel, Vuejs, Webpack",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fstore.gif?alt=media&token=09f4c34a-7341-42bc-aea0-c1e44b3b14f9",
    // 	categories: [this.categories.server, this.categories.nodejs, this.categories.web],
    // 	tags: [this.skills.html, this.skills.css, this.skills.javaScript, this.skills.vue, this.skills.node, this.skills.laravel]
    // },
    // {
    // 	id: "Vmax XS",
    // 	title: "Valour Max",
    // 	subtitle: "Android Development",
    // 	location: "",
    // 	categories: [this.categories.android, this.categories.firebase],
    // 	tags: [this.skills.android, this.skills.java, this.skills.firebase]
    // },
    // {
    // 	id: "Penfs",
    // 	title: "Pen Foundation School",
    // 	subtitle: "School Website & Admin Panel",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fpenfs.gif?alt=media&token=259c2c54-42ac-4e5b-b1af-3ce25b8be17b",
    // 	categories: [this.categories.design, this.categories.nodejs, this.categories.web],
    // 	tags: [this.skills.html, this.skills.css, this.skills.javaScript, this.skills.vue, this.skills.node, this.skills.laravel]
    // },
    // {
    // 	id: "Vmax MD",
    // 	title: "Valour Max Large",
    // 	subtitle: "Android",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fvmax-md.gif?alt=media&token=1a12ea72-f69c-420f-9a94-33a302abedb3",
    // 	categories: [this.categories.firebase, this.categories.android],
    // 	tags: [this.skills.java, this.skills.android, this.skills.firebase]
    // },
    // {
    // 	id: "G3",
    // 	title: "Go Designs",
    // 	subtitle: "",
    // 	location: "https://firebasestorage.googleapis.com/v0/b/brendan-portfolio.appspot.com/o/portfolio%2Fg3.png?alt=media&token=e86369a7-87fe-4fbd-97fb-970abb8a259d",
    // 	categories: [this.categories.design],
    // 	tags: []
    // }
    // ];
  },

  components: {
    PortfolioModal,
    Container,
    TabItem,
  },

  methods: {
    log(data) {
      console.log(data);
    },
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSkills") {
        if (state.skills != null) {
          this.skills = state.skills;
        }
      }

      if (mutation.type === "setCategories") {
        if (state.categories != null) {
          this.categories = state.categories;
        }
      }

      if (mutation.type === "setPortfolio") {
        if (state.portfolio != null) {
          this.portfolio_stacks = state.portfolio;
        }
      }
    });
  },

  mounted() {
    Event.$on("view-more", (data) => {
      this.log(data);
    });
  },
};
</script>
